var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconValuable40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2589_11184)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0046 5.50293H19.9684H27.9323C28.8525 5.50293 29.7215 5.92653 30.2884 6.65144L35.3788 13.1608C36.213 14.2275 36.2265 15.7215 35.4117 16.8031L22.37 34.1146C21.376 35.434 19.5006 35.6978 18.1812 34.7038C17.9589 34.5364 17.7611 34.3387 17.5935 34.1166L4.52789 16.8035C3.71162 15.7219 3.72448 14.2266 4.55923 13.1592L9.64841 6.65144C10.2153 5.92653 11.0843 5.50293 12.0046 5.50293Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6589 15.2061H36.2042L22 34.5034L20 35.5034L21 32.5034L26.6589 15.2061Z",
    fill: "#FAEC20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0046 5.50293H19.9684H27.9323C28.8525 5.50293 29.7215 5.92653 30.2884 6.65144L35.3788 13.1608C36.213 14.2275 36.2265 15.7215 35.4117 16.8031L22.37 34.1146C21.376 35.434 19.5006 35.6978 18.1812 34.7038C17.9589 34.5364 17.7611 34.3387 17.5935 34.1166L4.52789 16.8035C3.71162 15.7219 3.72448 14.2266 4.55923 13.1592L9.64841 6.65144C10.2153 5.92653 11.0843 5.50293 12.0046 5.50293Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4923 5.77873L25.8235 13.5447C26.3502 14.312 26.4897 15.2807 26.201 16.1655L19.9685 35.264L13.736 16.1655C13.4473 15.2807 13.5868 14.312 14.1135 13.5447L19.4446 5.77873C19.5631 5.60609 19.7591 5.50293 19.9685 5.50293C20.1779 5.50293 20.3738 5.60609 20.4923 5.77873Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07861 14.8496H35.8586",
    stroke: "#1E1E1E",
    strokeWidth: 1.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2589_11184"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconValuable40);
export default __webpack_public_path__ + "static/media/pictogramBeaconValuable40.017fc6a6049d31a32b857e844fab934a.svg";
export { ForwardRef as ReactComponent };